import {
  AspectRatio,
  Box,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from "@chakra-ui/react";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import Image from "next/legacy/image";
import NextLink from "next/link";
import { useRouter } from "next/router";
import { useIntl } from "react-intl";
import Copyright from "../../../components/Copyright";
import SignIn from "../SignIn";
import SignUp from "../SignUp";

const TABS_VALUE_SIGN_IN = "sign-in";
const TABS_VALUE_SIGN_UP = "sign-up";

function AuthLanding() {
  const router = useRouter();

  const intl = useIntl();

  return (
    <>
      <Box p="1rem">
        <AspectRatio ratio={1} position="relative" maxW="126px" mx="auto">
          <NextLink href={generateFrontPath({ id: "@home" })} passHref>
            <Image
              src={generateFrontPath({
                id: "internal-assets",
                parameters: { filePath: "logo.svg" },
                includeBasePath: true,
              })}
              layout="fill"
              alt="Centre Louise Michel"
            />
          </NextLink>
        </AspectRatio>
      </Box>

      <Tabs
        index={router.query.tab === TABS_VALUE_SIGN_IN ? 1 : 0}
        mt="1.5rem"
        display="flex"
        flexDirection="column-reverse"
        isFitted>
        <TabPanels>
          <TabPanel>
            <SignUp />
          </TabPanel>

          <TabPanel>
            <SignIn />
          </TabPanel>
        </TabPanels>

        <TabList position="sticky" top="0" zIndex={1} backgroundColor="#fff">
          <NextLink
            href={generateFrontPath({
              id: "@account",
              query: { ...router.query, tab: TABS_VALUE_SIGN_UP },
            })}
            shallow={true}
            passHref
            legacyBehavior>
            <Tab as="a">
              {intl.formatMessage({ defaultMessage: "Inscription" })}
            </Tab>
          </NextLink>

          <NextLink
            href={generateFrontPath({
              id: "@account",
              query: { ...router.query, tab: TABS_VALUE_SIGN_IN },
            })}
            shallow={true}
            passHref
            legacyBehavior>
            <Tab as="a">
              {intl.formatMessage({ defaultMessage: "Connexion" })}
            </Tab>
          </NextLink>
        </TabList>
      </Tabs>

      <Copyright />
    </>
  );
}

export default AuthLanding;
